// extracted by mini-css-extract-plugin
module.exports = {"text":"captionSkins-regular-text-ac46990b"};